export default {
  "widget.defaultTitle": "Porozmawiaj z nami",
  "widget.defaultSubtitle": "Chętnie pomożemy",
  "widget.defaultGreeting": "Cześć! Jak możemy Ci dziś pomóc?",
  "chat.close": "Zamknij czat",
  "chat.open": "Otwórz czat",
  "chat.expand": "Rozwiń czat",
  "chat.collapse": "Zwiń czat",
  "chat.conversationEnded": "Ta rozmowa została zakończona",
  "chat.startNew": "Rozpocznij Nową Rozmowę",
  "chat.poweredBy": "Wspierane przez",
  "chat.conversationClosed": "Rozmowa Zakończona",
  "chat.aiLabel": "Asystent AI",
  "input.placeholder": "Napisz wiadomość...",
  "input.send": "Wyślij wiadomość",
  "error.sendFailed": "Nie udało się wysłać wiadomości. Spróbuj ponownie za chwilę.",
  "error.messageTooLong": "Wiadomość jest za długa. Skróć ją i spróbuj ponownie.",
  "chat.teamMember": "Członek zespołu",
  "chat.agentJoined": "{name} dołącza do czatu",
  "chat.agentLeft": "{name} opuszcza czat",
  "chat.agentReturnedToAi": "{name} opuszcza czat. Ponownie rozmawiasz z asystentem AI.",
  "availability.open": "Otwarte teraz",
  "availability.backAt": "Wracamy {when}",
  "availability.closed": "Teraz niedostępni",
  "waiting.title": "Czekasz na konsultanta",
  "waiting.typical": "Zwykle odpowiada w {time}",
  "waiting.alerted": "Powiadomiliśmy zespół.",
  "waiting.closed": "Zespół wraca {when}. Do tego czasu asystent AI może dalej pomagać.",
  "waiting.minutes": "~{n} min",
  "waiting.hours": "~{n} godz.",
  "contact.prompt":
    "Zostaw swój e-mail, a wyślemy na niego odpowiedź zespołu, jeśli już wyjdziesz.",
  "contact.label": "E-mail",
  "contact.placeholder": "ty@przyklad.pl",
  "contact.submit": "Powiadom mnie",
  "contact.consent": "Użyjemy Twojego e-maila tylko do odpowiedzi w tej rozmowie.",
  "contact.saved": "Dziękujemy! Jeśli wyjdziesz, zanim zespół odpowie, wyślemy Ci e-mail.",
  "contact.failed": "Nie udało się zapisać e-maila. Sprawdź go i spróbuj ponownie.",
  "input.attach": "Dołącz zdjęcie lub PDF",
  "error.fileTooLarge": "Ten plik jest za duży. Zdjęcia i pliki PDF do 10 MB.",
  "error.fileType": "Możesz wysyłać zdjęcia (JPG, PNG, GIF, WebP) lub pliki PDF.",
  "error.fileFailed": "Nie udało się wysłać pliku. Spróbuj innego.",
  "attachment.photo": "Zdjęcie",
  "attachment.file": "Plik",
  "attachment.sending": "Wysyłanie...",
  "error.verificationFailed": "Nie udało się zweryfikować wiadomości. Odśwież stronę i spróbuj ponownie.",
  "challenge.label": "Kontrola bezpieczeństwa",
  "challenge.prompt": "Szybka kontrola bezpieczeństwa przed wysłaniem wiadomości.",
  "csat.defaultQuestion": "Jak oceniasz wsparcie, które otrzymałeś dzisiaj?",
  "csat.thankYou": "Dziękujemy za opinię!",
} as const;
